import {v4 as uuidv4} from 'uuid';

export const selectPeriodData = ['Last Month'];

export const startMonth = ['April 2023'];
export const endMonth = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const commissionEarningData = {
  heading: 'Commission Earning',
  headingSmallText: '(Financial Year 2022 - 2023)',
  price: '₹ 2,58,914',
  priceDtl:
    'Flights Commission - <span>₹ 74,678</span>, Hotels Commission - <span>₹ 81,900</span>, My Wallet Commission  - <span>₹ 1,02,336</span>',
  cta: 'DOWNLOAD INVOICE',
  infoText:
    'Please ensure that all the services have to listed as separate entries along with their respective HSN/SAC codes.',
};

export const detailedMonthData = {
  thead: [
    {
      id: uuidv4(),
      title: 'Month',
    },
    {
      id: uuidv4(),
      title: 'Flight Commission',
    },
    {
      id: uuidv4(),
      title: 'Hotel Commission',
      subTitle: 'Based on Checked-in',
    },
    {
      id: uuidv4(),
      title: 'My Wallet Commission',
    },
    {
      id: uuidv4(),
      title: 'Total Amount',
    },
  ],
  tbody: [
    {
      id: uuidv4(),
      rowData: [
        {
          id: uuidv4(),
          text: 'April 2022',
        },
        {
          id: uuidv4(),
          text: '₹ 6,532',
        },
        {
          id: uuidv4(),
          text: '₹ 6,825',
        },
        {
          id: uuidv4(),
          text: '₹ 8,582',
        },
        {
          id: uuidv4(),
          text: '₹ 21,939',
        },
      ],
    },
    {
      id: uuidv4(),
      rowData: [
        {
          id: uuidv4(),
          text: 'April 2022',
        },
        {
          id: uuidv4(),
          text: '₹ 6,532',
        },
        {
          id: uuidv4(),
          text: '₹ 6,825',
        },
        {
          id: uuidv4(),
          text: '₹ 8,582',
        },
        {
          id: uuidv4(),
          text: '₹ 21,939',
        },
      ],
    },
    {
      id: uuidv4(),
      rowData: [
        {
          id: uuidv4(),
          text: 'April 2022',
        },
        {
          id: uuidv4(),
          text: '₹ 6,532',
        },
        {
          id: uuidv4(),
          text: '₹ 6,825',
        },
        {
          id: uuidv4(),
          text: '₹ 8,582',
        },
        {
          id: uuidv4(),
          text: '₹ 21,939',
        },
      ],
    },
    {
      id: uuidv4(),
      rowData: [
        {
          id: uuidv4(),
          text: 'April 2022',
        },
        {
          id: uuidv4(),
          text: '₹ 6,532',
        },
        {
          id: uuidv4(),
          text: '₹ 6,825',
        },
        {
          id: uuidv4(),
          text: '₹ 8,582',
        },
        {
          id: uuidv4(),
          text: '₹ 21,939',
        },
      ],
    },
    {
      id: uuidv4(),
      rowData: [
        {
          id: uuidv4(),
          text: 'April 2022',
        },
        {
          id: uuidv4(),
          text: '₹ 6,532',
        },
        {
          id: uuidv4(),
          text: '₹ 6,825',
        },
        {
          id: uuidv4(),
          text: '₹ 8,582',
        },
        {
          id: uuidv4(),
          text: '₹ 21,939',
        },
      ],
    },
    {
      id: uuidv4(),
      rowData: [
        {
          id: uuidv4(),
          text: 'April 2022',
        },
        {
          id: uuidv4(),
          text: '₹ 6,532',
        },
        {
          id: uuidv4(),
          text: '₹ 6,825',
        },
        {
          id: uuidv4(),
          text: '₹ 8,582',
        },
        {
          id: uuidv4(),
          text: '₹ 21,939',
        },
      ],
    },
  ],
};

export const gstStepsData = [
  {
    id: uuidv4(),
    title: 'Generate Commission Invoice',
    description:
      'Enter your invoice number and generate a commission invoice for the selected period',
  },
  {
    id: uuidv4(),
    title: 'File GSTR1 on the Government GST Portal',
    description: 'Submit the commission invoice details while filing your GSTR1',
  },
  {
    id: uuidv4(),
    title: 'Upload Attested Commission Invoice Copy',
    description: 'Submit your GSTR1 proof along with an attested copy of the commission invoice',
  },
  {
    id: uuidv4(),
    title: 'Track Request',
    description: 'Track the status of your commission GST request in the Track Request section',
  },
];

export const sliderImages = [
  {
    id: uuidv4(),
    imgUrl: `https://assets-gos3.goibibo.com/myp_gst-1683207449.png`,
  },
];

export const commissionBreakupData = {
  heading: 'Financial Year 2022 - 2023 Commission Break Up',
  taxableAmount: '₹ 2,58,914.07',
  edit: 'Edit Amount',
  listData: [
    {
      id: uuidv4(),
      keyName: 'CGST (@9%)',
      value: '₹ 0',
    },
    {
      id: uuidv4(),
      keyName: 'SGST (@9%)',
      value: '₹ 0',
    },
    {
      id: uuidv4(),
      keyName: 'IGST (@18%)',
      value: '₹ 46,604',
    },
    {
      id: uuidv4(),
      keyName: 'Total Invoice Amount',
      value: '₹ 3,05,518',
    },
    {
      id: uuidv4(),
      keyName: 'GST on Commission Value',
      value: '₹ 46,604',
    },
    {
      id: uuidv4(),
      keyName: 'GST on Commission Value(in words)',
      value: 'Forty Six Thousand Six Hundred Four',
    },
  ],
};

export const submissionErrorData = {
  heading: 'There was an error with your submission:',
  listData: [
    {
      id: uuidv4(),
      text: 'The amount entered does not match the invoice - please review and correct.',
    },
    {
      id: uuidv4(),
      text: 'Please check the invoice number and try again.',
    },
    {
      id: uuidv4(),
      text: 'Please check the invoice date and try again.',
    },
  ],
};

export const gstInvoiceData = {
  month_wise_breakup: [
    [
      {
        id: uuidv4(),
        label: 'Month',
        width: '35%',
      },
      {
        id: uuidv4(),
        label: 'Commission Invoice Amount',
      },
      {
        id: uuidv4(),
        label: 'Status',
      },
      {
        id: uuidv4(),
        label: 'Action',
      },
    ],
    [
      {
        id: uuidv4(),
        label: 'April 2022',
      },
      {
        id: uuidv4(),
        label: '₹ 6,532',
      },
      {
        id: uuidv4(),
        status: 'credited',
        label: 'Credited',
      },
      {
        id: uuidv4(),
        action: '',
      },
    ],
  ],
};

export const trackGstInputData = {
  thead: [
    {
      id: uuidv4(),
      title: 'Month',
      width: '20%',
    },
    {
      id: uuidv4(),
      title: 'Submitted On',
    },
    {
      id: uuidv4(),
      title: 'Invoice Amount',
    },
    {
      id: uuidv4(),
      title: 'GST Credit Amount',
    },
    {
      id: uuidv4(),
      title: 'Processed Date',
    },
    {
      id: uuidv4(),
      title: 'Status',
    },
    {
      id: uuidv4(),
      title: 'Action',
      width: '12%',
    },
  ],
  tbody: [
    {
      id: uuidv4(),
      refId: 'NH12345',
      walletRechargeID: 'MYP100506916087',
      remarks: 'Invoice for the month April 2022 - June 2022',
      systemRemarks: 'Amount credited in your wallet',
      rowData: [
        {
          id: uuidv4(),
          from: 'Apr 22',
          to: 'Jun 2022',
        },
        {
          id: uuidv4(),
          text: '07 July 2022',
        },
        {
          id: uuidv4(),
          text: '₹ 21,939',
        },
        {
          id: uuidv4(),
          text: '₹ 1,939',
        },
        {
          id: uuidv4(),
          text: '10 July 2022',
        },
        {
          id: uuidv4(),
          status: 'credited',
          statusText: 'Credited',
        },
        {
          id: uuidv4(),
          action: 'See Details',
        },
      ],
    },
    {
      id: uuidv4(),
      refId: 'NH12345',
      walletRechargeID: '--',
      remarks: 'Invoice for the month July 2022 - Oct 2022',
      systemRemarks: 'Entry not found in GSTR1 portal',
      rowData: [
        {
          id: uuidv4(),
          from: 'Jul 22',
          to: 'Oct 2022',
        },
        {
          id: uuidv4(),
          text: '07 July 2022',
        },
        {
          id: uuidv4(),
          text: '₹ 21,939',
        },
        {
          id: uuidv4(),
          text: '₹ 1,939',
        },
        {
          id: uuidv4(),
          text: '10 July 2022',
        },
        {
          id: uuidv4(),
          status: 'rejected',
          statusText: 'Rejected',
        },
        {
          id: uuidv4(),
          action: 'See Details',
        },
      ],
    },
    {
      id: uuidv4(),
      refId: 'NH12345',
      walletRechargeID: '--',
      remarks: 'Invoice for the month January 2023',
      systemRemarks: '--',
      rowData: [
        {
          id: uuidv4(),
          from: 'Jan 2023',
        },
        {
          id: uuidv4(),
          text: '07 July 2022',
        },
        {
          id: uuidv4(),
          text: '₹ 21,939',
        },
        {
          id: uuidv4(),
          text: '₹ 1,939',
        },
        {
          id: uuidv4(),
          text: '--',
        },
        {
          id: uuidv4(),
          status: 'submitted',
          statusText: 'Submitted',
        },
        {
          id: uuidv4(),
          action: 'See Details',
        },
      ],
    },
  ],
};
